export const FETCH_PRODUCT_UNITS = {
  START: 'productUnitsDB: FETCH_START',
  SUCCESS: 'productUnitsDB: FETCH_SUCCESS',
  ERROR: 'productUnitsDB: FETCH_ERROR',
};
